export enum ProjectsActionType {
	FETCH_PROJECTS = 'FETCH_PROJECTS',
	STORE_PROJECTS = 'STORE_PROJECTS',
	ERROR_FETCH_PROJECTS = 'ERROR_FETCH_PROJECTS',

	ADD_PROJECT = 'ADD_PROJECT',

	FETCH_PROJECT_DETAILS = 'FETCH_PROJECT_DETAILS',
	ERROR_FETCH_PROJECTS_DETAILS = 'ERROR_FETCH_PROJECTS_DETAILS',
	STORE_PROJECT_DETAILS = 'STORE_PROJECT_DETAILS',

	UPDATE_PROJECT_DETAILS = 'UPDATE_PROJECT_DETAILS',

	DELETE_PROJECT = 'DELETE_PROJECT',

	FETCH_COLLABORATOR_AUTOCOMPLETE = 'FETCH_COLLABORATOR_AUTOCOMPLETE',
	ERROR_FETCH_COLLABORATOR_AUTOCOMPLETE = 'ERROR_FETCH_COLLABORATOR_AUTOCOMPLETE',
	STORE_COLLABORATOR_AUTOCOMPLETE = 'STORE_COLLABORATOR_AUTOCOMPLETE',

	FETCH_ASSIGNEE_AUTOCOMPLETE = 'FETCH_ASSIGNEE_AUTOCOMPLETE',
	ERROR_FETCH_ASSIGNEE_AUTOCOMPLETE = 'ERROR_FETCH_ASSIGNEE_AUTOCOMPLETE',
	STORE_ASSIGNEE_AUTOCOMPLETE = 'STORE_ASSIGNEE_AUTOCOMPLETE',

	FETCH_AUTOCOMPLETE_LEAD_DESIGNER = 'FETCH_AUTOCOMPLETE_LEAD_DESIGNER',
	ERROR_FETCH_AUTOCOMPLETE_LEAD_DESIGNER = 'ERROR_FETCH_AUTOCOMPLETE_LEAD_DESIGNER',
	STORE_AUTOCOMPLETE_LEAD_DESIGNER = 'STORE_AUTOCOMPLETE_LEAD_DESIGNER',

	FETCH_PROJECT_ACTIVITIES = 'FETCH_PROJECT_ACTIVITIES',
	STORE_PROJECT_ACTIVITIES = 'STORE_PROJECT_ACTIVITIES',
	ERROR_PROJECT_ACTIVITIES = 'ERROR_PROJECT_ACTIVITIES',

	COMPLETE_PROJECT_ACTIVITY = 'COMPLETE_PROJECT_ACTIVITY',

	FETCH_ALL_APPROVAL = 'FETCH_ALL_APPROVAL',
	ERROR_ALL_APPROVAL = 'ERROR_ALL_APPROVAL',
	STORE_ALL_APPROVAL = 'STORE_ALL_APPROVAL',

	UPDATE_ACTIVITY_DETAILS = 'UPDATE_ACTIVITY_DETAILS',

	APPROVE_REQUEST = 'APPROVE_REQUEST',
	REJECT_REQUEST = 'REJECT_REQUEST',

	COMPLETE_SITE_VISIT = 'COMPLETE_SITE_VISIT',

	UPLOAD_ACTIVITY_DOCUMENT = 'UPLOAD_ACTIVITY_DOCUMENT',

	FETCH_ACTIVITY_DOCUMENTS = 'FETCH_ACTIVITY_DOCUMENTS',
	ERROR_FETCH_ACTIVITY_DOCUMENTS = 'ERROR_FETCH_ACTIVITY_DOCUMENTS',
	STORE_ACTIVITY_DOCUMENTS = 'STORE_ACTIVITY_DOCUMENTS',
	RESET_ACTIVITY_DOCUMENTS = 'RESET_ACTIVITY_DOCUMENTS',

	DELETE_ACTIVITY_DOCUMENTS = 'DELETE_ACTIVITY_DOCUMENTS',

	FETCH_APPROVAL_DOCUMENTS = 'FETCH_APPROVAL_DOCUMENTS',
	STORE_APPROVAL_DOCUMENTS = 'STORE_APPROVAL_DOCUMENTS',

	FETCH_WARRANTY_CLAIMS = 'FETCH_WARRANTY_CLAIMS',
	STORE_WARRANTY_CLAIMS = 'STORE_WARRANTY_CLAIMS',
	ERROR_WARRANTY_CLAIMS = 'ERROR_WARRANTY_CLAIMS',
	FETCH_WARRANTY_CLAIM_BY_ID = 'FETCH_WARRANTY_CLAIM_BY_ID',
	STORE_WARRANTY_CLAIM_DETAILS = 'STORE_WARRANTY_CLAIM_DETAILS',
	ERROR_WARRANTY_CLAIM_DETAILS = 'ERROR_WARRANTY_CLAIM_DETAILS',
	UPDATE_WARRANTY_CLAIM = 'UPDATE_WARRANTY_CLAIM',
	APPROVE_WARRANTY_CLAIM = 'APPROVE_WARRANTY_CLAIM',
	REJECT_WARRANTY_CLAIM = 'REJECT_WARRANTY_CLAIM',
	SCHEDULE_WARRANTY_CLAIM = 'SCHEDULE_WARRANTY_CLAIM',
	UPDATE_WARRANTY_CLAIM_SCHEDULE = 'UPDATE_WARRANTY_CLAIM_SCHEDULE',
	SUBMIT_WARRANTY_QUOTE = 'SUBMIT_WARRANTY_QUOTE',
	SUBMIT_WARRANTY_FINAL_QUOTE = 'SUBMIT_WARRANTY_FINAL_QUOTE',
	UPDATE_WARRANTY_CHARGES = 'UPDATE_WARRANTY_CHARGES',
	UPDATE_WARRANTY_CLAIM_STATUSES = 'UPDATE_WARRANTY_CLAIM_STATUSES',
	UPDATE_WARRANTY_CLAIM_DISCOUNT = 'UPDATE_WARRANTY_CLAIM_DISCOUNT',
	FETCH_WARRANTY_DOCUMENTS = 'FETCH_WARRANTY_DOCUMENTS',
	STORE_WARRANTY_DOCUMENTS = 'STORE_WARRANTY_DOCUMENTS',
	ERROR_APPROVAL_DOCUMENTS = 'ERROR_APPROVAL_DOCUMENTS',

	FETCH_LEDGER_DATA = 'FETCH_LEDGER_DATA',
	STORE_LEDGER_DATA = 'STORE_LEDGER_DATA',
	ERROR_LEDGER_DATA = 'ERROR_LEDGER_DATA',
	RECALCULATE_LEDGER = 'RECALCULATE_LEDGER',
	ADD_DISCOUNT = 'ADD_DISCOUNT',
	ERROR_DISCOUNT = 'ERROR_DISCOUNT',
	EDIT_DISCOUNT_AMOUNT = 'EDIT_DISCOUNT_AMOUNT',
	EDIT_CASH_DISCOUNT_AMOUNT = 'EDIT_CASH_DISCOUNT_AMOUNT',

	FETCH_PROJECT_DISCOUNTS = 'FETCH_PROJECT_DISCOUNTS',
	STORE_PROJECT_DISCOUNTS = 'STORE_PROJECT_DISCOUNTS',
	ERROR_PROJECT_DISCOUNTS = 'ERROR_PROJECT_DISCOUNTS',

	APPLY_PROMO_CODE = 'APPLY_PROMO_CODE',
	ERROR_APPLY_PROMO_CODE = 'ERROR_APPLY_PROMO_CODE',

	REMOVE_PROMO_CODE = 'REMOVE_PROMO_CODE',
	ERROR_REMOVE_PROMO_CODE = 'ERROR_REMOVE_PROMO_CODE',

	FETCH_FLOOR_PLAN_IMAGE = 'FETCH_FLOOR_PLAN_IMAGE',
	STORE_FLOOR_PLAN_IMAGE = 'STORE_FLOOR_PLAN_IMAGE',
	ERROR_FLOOR_PLAN_IMAGE = 'ERROR_FLOOR_PLAN_IMAGE',

	FETCH_ORDERS = 'FETCH_ORDERS',
	STORE_ORDERS = 'STORE_ORDERS',
	ERROR_FETCH_ORDERS = 'ERROR_FETCH_ORDERS',

	FETCH_ASSIGNEE_DROPDOWN = 'FETCH_ASSIGNEE_DROPDOWN',
	ERROR_FETCH_ASSIGNEE_DROPDOWN = 'ERROR_FETCH_ASSIGNEE_DROPDOWN',
	STORE_ASSIGNEE_DROPDOWN = 'STORE_ASSIGNEE_DROPDOWN',

	FETCH_DESIGNER_DROPDOWN = 'FETCH_DESIGNER_DROPDOWN',
	ERROR_FETCH_DESIGNER_DROPDOWN = 'ERROR_FETCH_DESIGNER_DROPDOWN',
	STORE_DESIGNER_DROPDOWN = 'STORE_DESIGNER_DROPDOWN',

	FETCH_PRODUCTION_DROPDOWN = 'FETCH_PRODUCTION_DROPDOWN',
	ERROR_FETCH_PRODUCTION_DROPDOWN = 'ERROR_FETCH_PRODUCTION_DROPDOWN',
	STORE_PRODUCTION_DROPDOWN = 'STORE_PRODUCTION_DROPDOWN',

	FETCH_QC_DROPDOWN = 'FETCH_QC_DROPDOWN',
	ERROR_FETCH_QC_DROPDOWN = 'ERROR_FETCH_QC_DROPDOWN',
	STORE_QC_DROPDOWN = 'STORE_QC_DROPDOWN',

	FETCH_PROJECT_ASSIGNEES = 'FETCH_PROJECT_ASSIGNEES',
	ERROR_PROJECT_ASSIGNEES = 'ERROR_PROJECT_ASSIGNEES',
	STORE_PROJECT_ASSIGNEES = 'STORE_PROJECT_ASSIGNEES',

	FETCH_FINANCE_DROPDOWN = 'FETCH_FINANCE_DROPDOWN',
	ERROR_FETCH_FINANCE_DROPDOWN = 'ERROR_FETCH_FINANCE_DROPDOWN',
	STORE_FINANCE_DROPDOWN = 'STORE_FINANCE_DROPDOWN',

	FETCH_PROCUREMENT_DROPDOWN = 'FETCH_PROCUREMENT_DROPDOWN',
	ERROR_FETCH_PROCUREMENT_DROPDOWN = 'ERROR_FETCH_PROCUREMENT_DROPDOWN',
	STORE_PROCUREMENT_DROPDOWN = 'STORE_PROCUREMENT_DROPDOWN',

	FETCH_MANUFACTURING_DROPDOWN = 'FETCH_MANUFACTURING_DROPDOWN',
	ERROR_FETCH_MANUFACTURING_DROPDOWN = 'ERROR_FETCH_MANUFACTURING_DROPDOWN',
	STORE_MANUFACTURING_DROPDOWN = 'STORE_MANUFACTURING_DROPDOWN',

	FETCH_PROJECT_MANAGEMENT_DROPDOWN = 'FETCH_PROJECT_MANAGEMENT_DROPDOWN',
	ERROR_FETCH_PROJECT_MANAGEMENT_DROPDOWN = 'ERROR_FETCH_PROJECT_MANAGEMENT_DROPDOWN',
	STORE_PROJECT_MANAGEMENT_DROPDOWN = 'STORE_PROJECT_MANAGEMENT_DROPDOWN',
	FETCH_PROJECT_WARRANTY = 'FETCH_PROJECT_WARRANTY',
	STORE_PROJECT_WARRANTY = 'STORE_PROJECT_WARRANTY',
	ERROR_PROJECT_WARRANTY = 'ERROR_PROJECT_WARRANTY',
	PUT_LIFETIME_WARRANTY = 'PUT_LIFETIME_WARRANTY',

	FETCH_DESCOPE_APPROVALS = 'FETCH_DESCOPE_APPROVALS',
	STORE_DESCOPE_APPROVALS = 'STORE_DESCOPE_APPROVALS',
	ERROR_DESCOPE_APPROVALS = 'ERROR_DESCOPE_APPROVALS',
	APPROVE_DESCOPE_REQUEST = 'APPROVE_DESCOPE_REQUEST',

	FETCH_OPTIMIZED_CUTLIST_DATA = 'FETCH_OPTIMIZED_CUTLIST_DATA',
	STORE_OPTIMIZED_CUTLIST_DATA = 'STORE_OPTIMIZED_CUTLIST_DATA',
	ERROR_OPTIMIZED_CUTLIST_DATA = 'ERROR_OPTIMIZED_CUTLIST_DATA'
}
